/*
 * XPoost search: fast live results + animations.
 * - Results are cached per word, old requests are cancelled, only a few results per group are asked for.
 * - A shimmering placeholder shows while results load; results slide in one by one.
 * - Tapping a product in the results opens the quick view (no page load). Hover/touch warms it up.
 * - Pressing search plays a short "finding your products" transition, then opens the results page.
 */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var AR = /^ar/i.test(document.documentElement.lang || '') || document.documentElement.dir === 'rtl';
  var LABEL = AR ? 'ثواني بنجيبلك النتايج' : 'Finding your products';
  var veilEl = null;
  function veil() {
    if (veilEl && document.body.contains(veilEl)) return veilEl;
    veilEl = document.createElement('div');
    veilEl.id = 'xps-veil';
    veilEl.setAttribute('aria-hidden', 'true');
    veilEl.innerHTML = '<span class="xps-bar"></span><span class="xps-ring"></span><p>' + LABEL + '</p>';
    document.body.appendChild(veilEl);
    return veilEl;
  }
  function resetNav() {
    var v = document.getElementById('xps-veil');
    if (v) v.classList.remove('on');
    var p = document.querySelector('[data-search-popup]');
    if (p) p.classList.remove('xps-leave');
    window.__xpsLeaving = false;
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) resetNav(); });
  function handleOf(href) {
    var m = (href || '').split('/products/')[1];
    if (!m) return '';
    m = m.split(/[?#\/]/)[0];
    try { return decodeURIComponent(m); } catch (e) { return m; }
  }
  function qv() { return window.MinimogTheme && window.MinimogTheme.ProductQuickView; }
  function skeleton() {
    var row = '<div class="xps-skel"><i></i><span><b></b><b></b></span></div>';
    return '<div class="xps-skel-wrap">' + row + row + row + row + '</div>';
  }

  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        searchQuery: '[data-query]', searchMessage: '[data-message]',
        input: "[data-search-input], .m-search--form input[name='q']",
        submit: 'button[type="submit"]', loading: '[data-spinner]', clear: '[data-clear-search]',
        popularSearchItems: ['[data-ps-item]'], moreResultIcon: '[data-more-result-icon]'
      };
      this.container = document.querySelector('[data-search-popup]') || this;
      this.domNodes = queryDomNodes(this.selectors, this.container);
      this.cachedResults = {};
      this.inflight = null;
      this.input = this.querySelector('input[type="search"], .m-search--form input[name="q"]');
      this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
      this.searchPopupSearults = this.querySelector('.m-search-popup__result');
      this.popularSearches = this.querySelector('[data-popular-searches]');
      this.searchCount = this.querySelector('[data-search-count]');
      this.getCurrentLocalePrefix();
      this.setupEventListeners();
    }
    getCurrentLocalePrefix() {
      var m = window.location.pathname.match(/^\/([a-z]{2}(?:-[a-z]{2})?)\//i);
      this.currentLocalePrefix = m ? '/' + m[1] : '';
    }
    setPopularSearchesLink = () => {
      var items = this.domNodes.popularSearchItems;
      items.forEach(function (n) { n.href = createSearchLink(n.dataset.psQuery); });
    };
    setupEventListeners() {
      var self = this, clear = this.domNodes.clear;
      var form = this.querySelector('form.m-search-form, form.m-search--form');
      if (form) form.addEventListener('submit', this.onFormSubmit.bind(this));
      if (this.input) this.input.addEventListener('input', debounce(function (e) { self.onChange(e); }, 180).bind(this));
      if (clear) clear.addEventListener('click', this.onClearSearch.bind(this));
      MinimogEvents.subscribe(MinimogTheme.pubSubEvents.closeSearchPopup, function () { self.close(true); });

      /* Press search / "see all results" / a popular word: play the transition, then go. */
      this.addEventListener('click', function (e) {
        var go = e.target.closest('.m-search-form--button, .m-search--form-button, .m-search-count-result');
        if (go && self.getQuery().length) { e.preventDefault(); e.stopPropagation(); self.leaveTo(self.formUrl()); return; }
        var pop = e.target.closest('[data-ps-item]');
        if (pop && pop.href && !(e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0)) { e.preventDefault(); e.stopPropagation(); self.leaveTo(pop.href); return; }
        /* Tap a product: quick view instead of a page load. */
        var a = e.target.closest('a.m-search-item--with-thumbnail');
        if (!a || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        var h = handleOf(a.getAttribute('href')), q = qv();
        if (!h || !q || typeof q.open !== 'function') return;
        e.preventDefault(); e.stopPropagation();
        q.open(h, a);
      }, true);

      /* Warm the product up as soon as the shopper shows interest. */
      var warm = function (e) {
        var a = e.target.closest && e.target.closest('a.m-search-item--with-thumbnail');
        var q = qv();
        if (a && q && q.prefetch) q.prefetch(handleOf(a.getAttribute('href')));
      };
      this.addEventListener('pointerover', warm, { passive: true });
      this.addEventListener('touchstart', warm, { passive: true });
    }
    formUrl() {
      var f = this.querySelector('form.m-search-form, form.m-search--form');
      if (!f) return '/search?q=' + encodeURIComponent(this.getQuery());
      var p = new URLSearchParams(new FormData(f));
      return (f.getAttribute('action') || '/search').split('?')[0] + '?' + p.toString();
    }
    leaveTo(url) {
      if (window.__xpsLeaving) return;
      window.__xpsLeaving = true;
      var pop = document.querySelector('[data-search-popup]');
      if (pop) pop.classList.add('xps-leave');
      var v = veil();
      void v.offsetWidth;
      v.classList.add('on');
      setTimeout(function () { window.location.assign(url); }, reduce ? 0 : 340);
      /* Safety: if the page did not change, let the shopper try again. */
      setTimeout(resetNav, 9000);
    }
    getQuery() { return this.input ? this.input.value.trim() : ''; }
    onChange() {
      var q = this.getQuery();
      if (q.length) this.getSearchResults(q); else { if (this.inflight) this.inflight.abort(); this.toggleSpinnerLoading(false); this.close(true); }
    }
    onFormSubmit(e) {
      e.preventDefault();
      if (this.getQuery().length && !this.querySelector('[aria-selected="true"] a')) this.leaveTo(this.formUrl());
    }
    onClearSearch(e) {
      e.preventDefault();
      this.input.value = '';
      this.onChange();
    }
    showSkeleton() {
      if (!this.predictiveSearchResults) return;
      this.predictiveSearchResults.innerHTML = skeleton();
      this.predictiveSearchResults.classList.remove('m:hidden');
      if (this.searchPopupSearults) this.searchPopupSearults.classList.remove('m:hidden');
      this.open();
      if (this.searchCount) this.searchCount.classList.add('m:hidden');
    }
    getSearchResults(q) {
      var self = this;
      var key = q.toLowerCase();
      this.toggleSpinnerLoading(true);
      this.toggleClearSearch(false);
      var byTag = this.dataset.searchByTag === 'true', byBody = this.dataset.searchByBody === 'true';
      var unavailable = this.dataset.unavailableProductsOption;
      var fields = 'title,product_type,vendor,variants.sku,variants.title';
      if (byTag) fields += ',body';
      if (byBody) fields += ',tag';
      if (this.cachedResults[key]) { this.renderSearchResults(this.cachedResults[key]); return; }
      if (!this.hasAttribute('results')) this.showSkeleton();
      if (this.inflight) this.inflight.abort();
      var ctl = this.inflight = new AbortController();
      var base = window.MinimogSettings.routes.predictive_search_url;
      base = base.replace(/^\/[a-z]{2}(-[a-z]{2})?\//i, '/');
      if (base.charAt(0) !== '/') base = '/' + base;
      var url = '/en' + base + '?q=' + encodeURIComponent(q) + '&resources[options][unavailable_products]=' + unavailable +
        '&resources[options][fields]=' + fields + '&resources[limit]=6&resources[limit_scope]=each&section_id=predictive-search';
      fetch(url, { signal: ctl.signal }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      }).then(function (text) {
        var t = text.replace(/href="\/en\//g, 'href="' + self.currentLocalePrefix + '/').replace(/href='\/en\//g, "href='" + self.currentLocalePrefix + '/');
        var el = new DOMParser().parseFromString(t, 'text/html').querySelector('#shopify-section-predictive-search');
        var html = el ? el.innerHTML : '';
        self.cachedResults[key] = html;
        if (ctl !== self.inflight) return;
        self.renderSearchResults(html);
      }).catch(function (err) {
        if (err && err.name === 'AbortError') return;
        self.toggleSpinnerLoading(false);
        self.close();
      });
    }
    renderSearchResults(html) {
      this.predictiveSearchResults.innerHTML = html;
      this.setAttribute('results', true);
      var wrap = this.querySelector('[data-search-items-wrapper]');
      this.renderSearchQueryAndMessage(!!(wrap && wrap.childElementCount > 0));
      /* order of appearance + quick view fly-out hook */
      var i = 0;
      this.predictiveSearchResults.querySelectorAll('.m-search-item--with-thumbnail, .m-predictive-search__list-item').forEach(function (n) {
        n.style.setProperty('--i', Math.min(i++, 10));
        if (n.matches('a.m-search-item--with-thumbnail')) n.setAttribute('data-product-id', n.getAttribute('href') || '1');
      });
      this.toggleSpinnerLoading(false);
      this.toggleClearSearch(true);
      this.open();
    }
    renderSearchQueryAndMessage(has) {
      var d = this.domNodes, input = d.input, sq = d.searchQuery, sm = d.searchMessage, icon = d.moreResultIcon;
      if (!sq || !sm) return;
      sq.textContent = input.value;
      var title = sm.dataset.resultsTitle;
      this.predictiveSearchResults.classList.remove('m:hidden');
      if (this.searchPopupSearults) this.searchPopupSearults.classList.remove('m:hidden');
      if (has) { sm.textContent = title; if (icon) icon.classList.add('m:hidden'); }
      else { sm.textContent = sm.dataset.resultsTitle; if (icon) icon.classList.remove('m:hidden'); }
    }
    toggleSpinnerLoading(on) {
      var d = this.domNodes;
      if (d.submit) d.submit.style.visibility = on ? 'hidden' : 'visible';
      if (d.loading) d.loading.style.visibility = on ? 'visible' : 'hidden';
      this.classList.toggle('xps-loading', !!on);
    }
    toggleClearSearch(on) {
      var c = this.domNodes.clear;
      if (c) c.style.visibility = on ? 'visible' : 'hidden';
    }
    open() {
      if (this.searchPopupSearults) this.searchPopupSearults.style.setProperty('--search-result-max-height', (this.resultsMaxHeight || this.getResultsMaxHeight()) + 'px');
      this.setAttribute('open', true);
      this.input.setAttribute('aria-expanded', true);
      this.isOpen = true;
      if (this.popularSearches) this.popularSearches.classList.add('m:hidden');
      if (this.searchCount && this.hasAttribute('results') && !this.predictiveSearchResults.querySelector('.xps-skel')) this.searchCount.classList.remove('m:hidden');
    }
    close(clear) {
      if (clear === true) {
        this.input.value = '';
        this.removeAttribute('results');
        this.toggleClearSearch(false);
        this.resultsMaxHeight = false;
      }
      this.removeAttribute('open');
      this.predictiveSearchResults.classList.add('m:hidden');
      if (this.searchPopupSearults) this.searchPopupSearults.classList.add('m:hidden');
      if (this.popularSearches) this.popularSearches.classList.remove('m:hidden');
      if (this.searchCount) this.searchCount.classList.add('m:hidden');
    }
    getResultsMaxHeight() {
      var n = document.querySelector('predictive-search');
      this.resultsMaxHeight = window.innerHeight - (n ? n.getBoundingClientRect().bottom : 0);
      return this.resultsMaxHeight;
    }
  }
  customElements.define('predictive-search', PredictiveSearch);
})();
